import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class GrabFilter extends Component {
    state = {
        grabFilterLists: [{value: '0', label: 'All'},{value: '1', label: 'Grab Transactions'}],
        grabFilterValue: {value: '0', label: 'All'},
        isGrabFilterLoading: false,
        isDisabled:false
    };
    componentDidMount(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        this.setState({
            userGroupName:decoded.userGroupName
        })


    }

    resetGrabFilter(){

       this.setState({
                grabFilterValue: {value: '', label: 'All'},
            })

    }


    changeGrabFilterType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            grabFilterValue:optionSelected,
        });
        this.props.onSelectGrabFilter(optionSelected, value);
    }

    render() {

        return (
            <Select name="grab_filter"
            isDisabled={this.state.isDisabled}
            value={this.state.grabFilterValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeGrabFilterType.bind(this)}
            options={this.state.grabFilterLists}
            isLoading={this.state.isGrabFilterLoading}
            placeholder="[Transactions Type]"
         />
        );

    }
}
export default GrabFilter;